import { useNicheContextManager } from 'modules/niche/common/hooks'

import { useBrandTerritoryResolver } from '../use-brand-territory-resolver'
import { BRAND_CONTEXTS_BY_TYPE } from './use-brand-niche-context-manager.consts'
import type { IUseBrandNicheContextManager } from './use-brand-niche-context-manager.types'

export function useBrandNicheContextManager({
  territoryId,
  brandContentType,
  skipDefaultContexts,
  initialContextId,
}: IUseBrandNicheContextManager) {
  const { getTerritoryIdForContext, isReady } = useBrandTerritoryResolver({
    territoryId,
    brandContentType,
  })

  const customDefaultContexts = brandContentType ? BRAND_CONTEXTS_BY_TYPE[brandContentType] : undefined
  const hideCreateContext = brandContentType === 'total'

  return useNicheContextManager({
    territoryId,
    skipDefaultContexts,
    initialContextId,
    customDefaultContexts,
    territoryIdResolver: getTerritoryIdForContext,
    readinessCheck: { isReady },
    hideCreateContext,
    featureType: 'brands',
  })
}
